import * as complaintPositionsTypes from '../types/ComplaintPositions';
import {INITIAL_STATE} from './state/ComplaintPositions';
import {TEST_STATE} from './state/ComplaintPositionsForTests'; //eslint-disable-line no-unused-vars
import {COMPLAINT_SEARCH_COMPLAINT_SUCCESS} from '../types/Complaint';
import * as pageTypes from '../types/Page';

export default function (state = INITIAL_STATE, action) {
    switch(action.type) {
        case complaintPositionsTypes.COMPLAINT_POSITIONS_ADD_COMPLAINT_POSITION:
            return { 
                ...state, 
                positions: [...state.positions, action.payload]
            }; 
        case complaintPositionsTypes.COMPLAINT_POSITIONS_ADD_SINGLE_COMPLAINT_POSITION:
            return { 
                ...state, 
                positions: [...state.positions, action.payload]
            }; 
        case complaintPositionsTypes.EDIT_COMPLAINT_POSITION:
            return { 
                ...state, 
                positions: state.positions.map(item => {
                if(item.id !== action.payload.id) {
                    return item; // This isn't the item we care about - keep it as-is
                }
                // Otherwise, this is the one we want - return an updated value
                return {
                    ...item,
                    ...action.payload
                };
                })
        };
        case complaintPositionsTypes.DELETE_COMPLAINT_POSITION:
        return{
            ...state,
            positions: state.positions.filter((positonToRemove) => positonToRemove !== action.complaintPosition)
        };
        case COMPLAINT_SEARCH_COMPLAINT_SUCCESS:
            return { 
                ...state, 
                positions: action.payload.complaintPositions
            };
        case pageTypes.PAGE_GO_TO_COMPLAINT_PREVIEW_PAGE:
        case pageTypes.PAGE_GO_TO_START_PAGE: 
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE:
        case pageTypes.PAGE_GO_TO_CREATE_COMPLAINT_PAGE_WITHOUT_CUSTOMER_DATA_CLEAR:
            return INITIAL_STATE;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/ComplaintPositions.js